// extracted by mini-css-extract-plugin
export default {"root":"List_root__4oA5l","wrapper":"List_wrapper__EAlSR","list":"List_list__469Om"};